'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var session = require('../session/session.js');

function getUserName(method, userName) {
  if (userName === void 0) {
    const user = session.session.getUser();
    if (user) {
      return user.userName;
    } else {
      throw new Error("Username not specified and session not active in method " + method);
    }
  } else {
    return userName;
  }
}
function getUserTags(user) {
  const tags = [`user:${user.userName}`, `segment:${user.segment || 0}`];
  if (user.country) {
    tags.push(`country:${user.country}`);
  }
  if (user.lang) {
    tags.push(`lang:${user.lang}`);
  }
  if (user.affiliate) {
    tags.push(`affiliate:${user.affiliate}`);
  }
  if (user.location) {
    tags.push(`location:${user.location}`);
  }
  if (user.roles && user.roles.length) {
    user.roles.forEach((role) => tags.push(`role:${role}`));
  }
  if (!isNaN(user.depositCount)) {
    tags.push(`depositCount:${user.depositCount}`);
  }
  if (typeof user.notOnSiteMarketing === "boolean") {
    tags.push(`notOnSiteMarketing:${user.notOnSiteMarketing}`);
  }
  return tags;
}

exports.getUserName = getUserName;
exports.getUserTags = getUserTags;
